import { render, staticRenderFns } from "./BankFilter.vue?vue&type=template&id=b70fabaa&"
import script from "./BankFilter.vue?vue&type=script&lang=js&"
export * from "./BankFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports